'use client'

import { createContext, useContext } from 'react'

type ProductSellerVoucherLabelDiscountDialogContextValue = {
  showLinkToPromotionPage?: boolean
  showRecommendations?: boolean
  termsExpanded?: boolean
}

export const ProductSellerVoucherLabelDiscountDialogContextProvider =
  createContext<ProductSellerVoucherLabelDiscountDialogContextValue>({})

export const useProductSellerVoucherLabelDiscountDialogContext =
  (): ProductSellerVoucherLabelDiscountDialogContextValue =>
    useContext(ProductSellerVoucherLabelDiscountDialogContextProvider)
